import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { withRouter } from 'react-router'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as RouterDom from 'react-router-dom'
const RouterLink = RouterDom.Link

class Footer extends Component {

  render(){

    return(
      <Row style={{
        backgroundColor: '#383838',
        paddingTop: 70,
        paddingBottom: 70,
      }}>

        <Container style={{
          paddingLeft: 30,
          paddingRight: 30,
        }}>

          <Row style={{ marginTop : 0, }}>
            <Col style={{textAlign: 'right'}}>

              <RouterLink className="header_text" to="/privacy_policy" style={{
                color: '#ffffff',
                textDecoration: 'none',
              }}>
                プライバシーポリシー
              </RouterLink>

              <span style={{
                color: '#ffffff',
                marginRight: 5,
                marginLeft: 5,
              }}>
                |
              </span>

              <RouterLink className="header_text" to="/terms_of_use" style={{
                color: '#ffffff',
                textDecoration: 'none',
              }}>
                利用規約
              </RouterLink>
            </Col>
          </Row>

          <Row style={{ marginTop : 30, }}>
            <Col style={{textAlign: 'center'}}>
              <span style={{
                  fontSize: 14,
                  color: '#ffffff',
                }}>
                Ⓒ	<a href="https://shabelab.com" style={{
                  color: '#ffffff',
                  textDecoration: 'none',
                }}>Shabélab inc</a> all right reserved.
              </span>
            </Col>
          </Row>

        </Container>

      </Row>
    )
  }
}

export default Footer
